import { plus, sum, minus } from '@/utils/number';

export const loanTime = (time = 0, limit = 0) => {
    const min = new Date(time).getMinutes() * 60 * 1000;
    const sec = new Date(time).getSeconds() * 1000;
    const ms = new Date(time).getMilliseconds();
    const overTime = minus(time, sum([min, sec, ms]));
    const result = plus(overTime, (limit * 24 * 60 * 60 * 1000 - 1000));
    return result;
};
